import InputWithBottomBorder from "./InputWithBottomBorder";

export default InputWithBottomBorder;



// WEBPACK FOOTER //
// ./src/shared/components/InputWithBottomBorder/index.js